import type { FC, JSX } from 'react'
import type { IPopupComponentProps } from 'blocks/Popup'

import { ButtonFonts } from 'atoms/Button'
import { PrimaryButton } from 'atoms/Button/Templates'
import {
  WrapperBlock,
  WrapperDisplay,
  WrapperJustifyContent,
} from 'atoms/WrapperBlock'
import { PopupComponent } from 'blocks/Popup'
import { TextBlockRowGap } from 'blocks/TextBlock'
import { ShoppingCartPopupHeader } from 'blocks/TextBlock/Templates/Popup/ShoppingCartPopupHeader'
import { COLOR } from 'vars/color'

export interface PartnerProgramGoToAppPopupParamsI extends Omit<
  IPopupComponentProps,
  'children'
> {
  title: string
  description: string
  buttonTitle: string
  onClick: () => void
  isOpened: boolean
  isLoading?: boolean
}

export const PartnerProgramGoToAppPopup: FC<
  PartnerProgramGoToAppPopupParamsI
> = ({
  title = '',
  description = '',
  overlayColor = COLOR.SURFACE_OPACITY_DARK_70,
  buttonTitle = '',
  onClick,
  isOpened = false,
  isShoppingCartPopup = true,
  isLoading,
  ...rest
}): JSX.Element | null => {
  return isOpened ? (
    <PopupComponent
      overlayColor={overlayColor}
      isShoppingCartPopup={isShoppingCartPopup}
      {...rest}
    >
      <ShoppingCartPopupHeader
        title={title}
        description={description}
        rowGap={TextBlockRowGap.INDENT_40}
      />
      <WrapperBlock
        display={WrapperDisplay.FLEX}
        justifyContent={WrapperJustifyContent.CENTER}
        width='100%'
      >
        <PrimaryButton
          title={buttonTitle}
          onClick={onClick}
          withLoader
          isLoading={isLoading}
          disabled={isLoading}
          font={ButtonFonts.Button1}
        />
      </WrapperBlock>
    </PopupComponent>
  ) : null
}
